import { EditorType, resolveEditorCapabilities } from '@wix/a11y-adapters';
import { EditorHost } from '../types';

/** Maps Storybook / panel {@link EditorHost} to platform {@link EditorType} for capability lookup. */
export function editorHostToEditorType(host) {
  switch (host) {
    case EditorHost.editor:
      return EditorType.Classic;
    case EditorHost.studio:
      return EditorType.Studio;
    case EditorHost.odeditor:
      return EditorType.OdEditor;
    case EditorHost.studiotwo:
      return EditorType.StudioTwo;
  }
}
export function resolveCapabilitiesForEditorHost(host) {
  return resolveEditorCapabilities(editorHostToEditorType(host));
}
//# sourceMappingURL=editor-capabilities-from-host.js.map